/**
 * Control whether we will enable SDUI web category page redesign
 */
export const ENABLE_SDUI_WEB_CATEGORY_PAGE_REDESIGN_240910 = 'ENABLE_SDUI_WEB_CATEGORY_PAGE_REDESIGN_240910';
